module.exports = __webpack_public_path__ + "static/media/logo-expanded.bafb1b99.svg";